import React from 'react';
import Appearance from '../StarAppearance/StarAppearance';
import Conditions from '../ConditionGroup/PropertyConditions';

export default ({ activeTab }) => {
  return (
    <>
      {activeTab === 1 && <Appearance />}
      {activeTab === 3 && <Conditions />}
    </>
  );
};
